module.exports = __webpack_public_path__ + "images/icons/flags/IL-da664680.svg";